module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('claim-blank-form', _vm._b({
    attrs: {
      "submit-label": "Сохранить",
      "form-type": "edit",
      "errors": _vm.errors
    },
    on: {
      "submit": _vm.processClaimForm
    }
  }, 'claim-blank-form', _vm.$attrs, false))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cf402f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/claim/ClaimEditForm.vue
// module id = 627
// module chunks = 0